import { BehaviorSubject, Observable } from 'rxjs';
import { Injectable, TemplateRef } from '@angular/core';

export interface ToolbarCustomisation {
  actionsRef?: TemplateRef<any>
  theme?: string;
}

@Injectable({
  providedIn: 'root',
})
export class ToolbarCustomisationService {
  private toolbarCustomisationsSource: BehaviorSubject<ToolbarCustomisation>;

  readonly toolbarCustomisations$: Observable<ToolbarCustomisation>;

  constructor() {
    this.toolbarCustomisationsSource = new BehaviorSubject<ToolbarCustomisation>({});
    this.toolbarCustomisations$ = this.toolbarCustomisationsSource.asObservable();
  }

  setToolbarCustomisation(toolbarCustomisations: ToolbarCustomisation) {
    this.toolbarCustomisationsSource.next(toolbarCustomisations);
  }
}
